import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_MEDIUM } from '../../../Constants/UI.constants';
import { DARKER_GREY, PRIMARY_BLUE, NOTE_RED } from '../../../Constants/Colors.constants';
import { TRANSITION_MATERIAL } from '~/Constants/CSS.constants';

export const NeoTextFieldStyles = (conditions: {
  withLabel: boolean;
  startAdornment: boolean;
  endAdornment: boolean;
  isText: boolean;
  hasError: boolean;
  isSelect?: boolean;
}) =>
  makeStyles(() => ({
    textFieldContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      minHeight: 50,
      boxSizing: 'border-box',
      justifyContent: 'space-between',
      color: conditions.hasError ? `${NOTE_RED} !important` : 'currentColor',
    },
    textareaContainer: {
      width: '100%',
      marginTop: '0 !important',
      '&:before': {
        content: 'none',
      },
      '&:after': {
        content: 'none',
      },
    },
    inputContainer: {
      width: conditions.isText ? 0 : 'fit-content',
      maxWidth: conditions.isText ? 'none' : 'fit-content',
      marginTop: '0 !important',
      color: 'currentColor',
      flexGrow: conditions.isText ? 1 : 0,
      borderColor: conditions.hasError ? NOTE_RED : DARKER_GREY,
      '&:before': {
        content: 'none',
      },
      '&:after': {
        content: 'none',
      },
      '& > svg': {
        marginRight: conditions.isSelect ? -16 : 0,
      },
    },
    input: {
      textAlign: conditions.withLabel ? 'right' : 'inherit',
      transition: `color ${TRANSITION_MATERIAL}`,
    },
    textarea: {
      textAlign: conditions.withLabel ? 'right' : 'inherit',
      transition: `color ${TRANSITION_MATERIAL}`,
      minHeight: conditions.withLabel ? '' : 100,
    },
    outlinedInput: {
      padding: '4px 0px',
      paddingRight: conditions.endAdornment ? 0 : 8,
      paddingLeft: conditions.startAdornment ? 0 : 8,
      maxWidth: 60,
      minWidth: 60,
      boxSizing: 'border-box',
      height: 33,
    },
    inputFocused: {
      borderColor: PRIMARY_BLUE,
    },
    notchedOutline: {
      borderRadius: 4,
      top: 0,
      borderColor: 'inherit !important',
      '&>legend': {
        display: 'none',
      },
    },
    label: {
      display: 'flex',
      alignItems: 'center',
    },
    labelBold: {
      fontWeight: '700',
    },
    labelContainer: {
      position: 'relative',
      transform: 'none !important',
      fontSize: FONT_SIZE_MEDIUM,
      lineHeight: '23px',
      color: 'currentColor !important',
      marginRight: 15,
      minWidth: 'fit-content',
    },
  }));
